import { render, staticRenderFns } from "./Zones.page.vue?vue&type=template&id=fc48aeea&scoped=true"
import script from "./Zones.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./Zones.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Zones.page.vue?vue&type=style&index=0&id=fc48aeea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc48aeea",
  null
  
)

export default component.exports